<template>
  <div class="action-sidebar">
    <slot />
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@use "~phoenix_styles/colors" as colors;

.action-sidebar {
  background: colors.$background-light-gray;
  border-radius: 8px;
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>
